import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const ListSubscribe = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M11.3999 16.1999C11.3999 17.4729 11.9056 18.6938 12.8058 19.594C13.706 20.4942 14.9269 20.9999 16.1999 20.9999C17.4729 20.9999 18.6938 20.4942 19.594 19.594C20.4942 18.6938 20.9999 17.4729 20.9999 16.1999C20.9999 14.9269 20.4942 13.706 19.594 12.8058C18.6938 11.9056 17.4729 11.3999 16.1999 11.3999C14.9269 11.3999 13.706 11.9056 12.8058 12.8058C11.9056 13.706 11.3999 14.9269 11.3999 16.1999Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.2 13.7998V18.5998"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.8 16.2002H18.6"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 16.2C3.00061 15.3073 3.22243 14.4286 3.64565 13.6426C4.06886 12.8565 4.68026 12.1876 5.42519 11.6957C6.17012 11.2037 7.02536 10.904 7.91444 10.8234C8.80351 10.7427 9.69871 10.8837 10.52 11.2336"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.1001 6.3C5.1001 7.17521 5.44778 8.01458 6.06665 8.63345C6.68552 9.25232 7.52488 9.6 8.4001 9.6C9.27531 9.6 10.1147 9.25232 10.7336 8.63345C11.3524 8.01458 11.7001 7.17521 11.7001 6.3C11.7001 5.42479 11.3524 4.58542 10.7336 3.96655C10.1147 3.34768 9.27531 3 8.4001 3C7.52488 3 6.68552 3.34768 6.06665 3.96655C5.44778 4.58542 5.1001 5.42479 5.1001 6.3V6.3Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
